import { connect } from "react-redux";

import {
  cancelCreditCardUpdates,
  cancelNewCardRecord,
  createNewLocalCard,
  removeCreditCard,
  returnCardErrors,
  saveCreditCardUpdates,
  saveNewCreditCard,
  saveNewCreditCardWithToken,
  toggleForm,
  updateCreditCardField,
  validateCCFieldOnBlur,
} from "actions/credit_cards";

import CreditCardList from "components/account/credit_card_list";

function mapStateToProps(state) {
  return {
    creditCardList: state.consumer.cards,
    storeInfo: state.storeInfo || null,
  };
}

const mapDispatchToProps = {
  onToggleForm: toggleForm,
  onCancelNewCardRecord: cancelNewCardRecord,
  onCreateNewLocalCard: createNewLocalCard,
  onSaveNewCreditCard: saveNewCreditCard,
  onCreditCardSave: saveCreditCardUpdates,
  onCreditCardCancel: cancelCreditCardUpdates,
  onCreditCardRemove: removeCreditCard,
  onUpdateCreditCardField: updateCreditCardField,
  onBlurValidateCCField: validateCCFieldOnBlur,
  onReturnCardErrors: returnCardErrors,
  onSaveNewCreditCardWithToken: saveNewCreditCardWithToken,
};

const CreditCardListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardList);

export default CreditCardListContainer;
